<template>
  <v-container fluid class="pa-0">
    <v-row align="center" justify="space-between" class="mb-5">
      <v-col cols="12" class="d-flex justify-space-between align-center">
        <div>
          <div class="page-title">Manage Interns</div>
          <div class="page-subtitle">Track performance and attendances of assigned interns.</div>
        </div>
        <v-text-field
          v-model="search"
          placeholder="Search interns..."
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          density="compact"
          hide-details
          clearable
          style="max-width: 280px;"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-row v-if="internData.length > 0">
          <v-col cols="4" v-for="i in filteredInterns" :key="i.id">
            <v-card flat rounded="xl" class="intern-card pa-4">
              <div class="d-flex align-center ga-3">
                <div class="intern-avatar">
                  <v-icon color="#9ca3af" size="22">mdi-account</v-icon>
                </div>
                <div>
                  <div class="intern-name">{{ i.name }}</div>
                  <div class="intern-program">{{ i.program_name }}</div>
                </div>
              </div>
              <div class="mt-3" v-if="!getIsFieldOfficerUser">
                <v-chip size="x-small" variant="tonal" color="primary" prepend-icon="mdi-office-building-outline">
                  {{ i.dept_office || 'No office assigned' }}
                </v-chip>
              </div>
              <div class="mt-4">
                <div class="d-flex justify-space-between mb-1">
                  <span class="hours-label">Hours Rendered</span>
                  <span class="hours-value">{{ i.ojt_data.total_completed_hrs }}/{{ i.ojt_data.ojt_hrs }} hrs</span>
                </div>
                <v-progress-linear
                  color="#00a63e"
                  height="8"
                  rounded="pill"
                  bg-color="#f3f4f6"
                  :model-value="(i.ojt_data.total_completed_hrs / i.ojt_data.ojt_hrs) * 100"
                />
                <div class="mt-1 text-right" style="font-size: 11px; color: #6b7280;">
                  {{ Math.round((i.ojt_data.total_completed_hrs / i.ojt_data.ojt_hrs) * 100) }}% complete
                </div>
              </div>
              <v-divider class="my-3" />
              <div class="d-flex ga-2">
                <v-btn
                  @click="i.isEvaluated == 0 ? add_evaluation(i) : null"
                  :disabled="i.isEvaluated == 1"
                  color="#00A63E"
                  variant="flat"
                  size="small"
                  rounded="lg"
                  class="text-white flex-1-1"
                  style="flex: 1;"
                >
                  <v-icon size="14" class="mr-1">mdi-star-outline</v-icon>
                  {{ i.isEvaluated == 0 ? "Evaluate" : "Evaluated" }}
                </v-btn>
                <v-btn
                  @click="viewDtrItem(i)"
                  color="primary"
                  variant="tonal"
                  size="small"
                  rounded="lg"
                  style="flex: 1;"
                >
                  <v-icon size="14" class="mr-1">mdi-calendar-clock</v-icon>
                  View DTR
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-card v-else flat rounded="xl" class="table-card pa-8 text-center">
          <v-icon size="48" color="grey-lighten-1">mdi-account-group-outline</v-icon>
          <div class="font-weight-bold mt-3" style="font-size: 15px; color: #374151;">No interns yet</div>
          <div class="text-grey mt-1" style="font-size: 13px;">Interns assigned to your organization will appear here.</div>
        </v-card>
      </v-col>
    </v-row>
    <InternEvaluationDialog :data="viewData" :action="action" />
    <ViewStudentDTRDialog :data="studentData" />

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </v-container>
</template>

<script>
import eventBus from "@/eventBus";
import InternEvaluationDialog from "../Dialogs/Forms/InternEvaluationDialog.vue";
import ViewStudentDTRDialog from "../Dialogs/Views/ViewStudentDTRDialog.vue";
export default {
  components: {
    InternEvaluationDialog,
    ViewStudentDTRDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    search: "",

    internData: [],
    showStudentMatching: false,
    itemData: null,
    viewData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    tabledata: [],
    studentData: null,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  mounted() {
    this.initialize();

    eventBus.on("closeInternEvaluationDialog", () => {
      this.initialize();
    });
    eventBus.on("closeViewStudentDTRDialog", () => {
      this.initialize();
    });
  },
  beforeUnmount() {
    eventBus.off("closeInternEvaluationDialog");
    eventBus.off("closeViewStudentDTRDialog");
  },

  computed: {
    getIsFieldOfficerUser() {
      return this.$store.state.user.user.usertypeID == 9;
    },
    filteredInterns() {
      if (!this.search) return this.internData;
      const q = this.search.toLowerCase();
      return this.internData.filter(
        (i) =>
          i.name?.toLowerCase().includes(q) ||
          i.program_name?.toLowerCase().includes(q) ||
          i.dept_office?.toLowerCase().includes(q),
      );
    },
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },

    initialize() {
      if (this.getIsFieldOfficerUser) {
        this.axiosCall("/organization/getMyAssignedInterns", "GET").then(
          (res) => {
            if (res) {
              console.log(res.data);
              this.internData = res.data;
            }
          },
        );
      } else {
        this.axiosCall("/organization/getMyInterns", "GET").then((res) => {
          if (res) {
            console.log(res.data);
            this.internData = res.data;

            // this.loading = false;
          }
        });
      }
    },

    getProgramNames(programs) {
      let arr = [];
      for (let i = 0; i < programs.length; i++) {
        for (let j = 0; j < this.programs.length; j++) {
          if (programs[i] == this.programs[j].id) {
            arr.push(this.programs[j].abbr);
          }
        }
      }
      return arr;
    },

    add_evaluation(item) {
      this.viewData = item;
      this.action = "Add";
    },

    viewDtrItem(item) {
      this.studentData = item;
    },

    async save() {
      let validate = await this.$refs.InternRequestForm.validate();
      if (validate.valid) {
        if (this.programSelected.length == 0) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Please select program.";
        } else {
          let data = {
            programSelected: JSON.stringify(this.programSelected),
            num_interns: this.num_interns,
            skills: JSON.stringify(this.selectedSkills),
          };

          this.axiosCall("/organization/add-intern-request", "POST", data).then(
            (res) => {
              if (res.data.status == 201) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
                this.showStudentMatching = true;
              } else if (res.data.status == 400) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
              }
            },
          );
        }
      }
    },

    viewMatching(item) {
      console.log(item);
      this.expandTab1 = true;
      this.showStudentMatching = true;
    },

    viewItem(item) {
      this.itemData = item;
      this.action = "View";
    },

    manageItem(item) {
      this.creds = item;
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },
  },
};
</script>

<style scoped>
.page-title {
  font-size: 30px;
  font-weight: 800;
  color: #111827;
  letter-spacing: -0.5px;
}
.page-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-top: 2px;
}
.table-card {
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}
.intern-card {
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s;
}
.intern-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.09);
}
.intern-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.intern-name {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}
.intern-program {
  font-size: 12px;
  color: #6b7280;
}
.hours-label {
  font-size: 12px;
  color: #6b7280;
}
.hours-value {
  font-size: 12px;
  font-weight: 600;
  color: #111827;
}
</style>
